<template>
  <v-container v-if="!pageLoading" class="my-16">
    <v-row justify="center">
      <v-col md="10">
        <v-card color="grey lighten-1" rounded="lg">
          <v-list color="transparent">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Sipariş Listesi</v-list-item-title>
                <v-list-item-subtitle>{{
                  detail.head.siparis_tarihi | moment('DD MMMM YYYY HH:mm, dddd ')
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text>Sipariş Numarası</v-list-item-action-text>
                <v-chip label small color="success" class="mt-1" outlined>{{ detail.head.id }}</v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-card-text>
            <v-list class="my-6 pa-0 rounded-lg overflow-hidden">
              <div v-for="(line, index) in detail.products" :key="`LIST-${index}`">
                <v-hover v-slot="{ hover }">
                  <v-list-item
                    :three-line="!$vuetify.breakpoint.mdAndUp"
                    :two-line="$vuetify.breakpoint.mdAndUp"
                    :class="hover ? 'nightDark' : null"
                    class="px-6 py-3"
                  >
                    <v-list-item-action>
                      <v-list-item-action-text> #{{ index + 1 }}</v-list-item-action-text>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-sheet :max-width="$vuetify.breakpoint.mdAndUp ? 120 : 80" color="transparent">
                        <CounterTo
                          :count="false"
                          :uid="line.uid"
                          :plant-id="line.selected_plant"
                          :miktar="line.qty"
                          :birim="line.birim || 'AD'"
                          :birim-ritim="line.birim_ritmi"
                          bg-color="counter"
                          button-color="black"
                          :light="true"
                          @refreshBasket="refreshBasket()"
                        />
                      </v-sheet>
                    </v-list-item-action>
                    <v-list-item-content :class="$vuetify.breakpoint.mdAndUp ? 'ml-6' : 'ml-2'">
                      <v-list-item-title
                        class="text-caption text-md-body-2 font-weight-bold pt-1"
                        :style="$vuetify.breakpoint.mdAndUp ? null : 'white-space: normal !important'"
                      >
                        {{ line.baslik }}
                      </v-list-item-title>

                      <v-list-item-subtitle class="mt-1">
                        {{ line.total_price | currency }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-hover>
                <v-divider></v-divider>
              </div>
            </v-list>
            <v-list color="transparent">
              <v-list-item>
                <v-list-item-content class="oneLine">
                  <v-list-item-title class="text-right"> Toplam Tutar </v-list-item-title>
                  <v-list-item-subtitle class="text-right">
                    {{ detail.head.total_price | currency }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="oneLine">
                  <v-list-item-title class="text-right"> KDV </v-list-item-title>
                  <v-list-item-subtitle class="text-right">
                    {{ detail.head.tax_price | currency }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="oneLine">
                  <v-list-item-title class="text-right">
                    <p class="pa-0 ma-0">Sipariş Toplam Tutarı</p>
                    <small class="text--disabled">(KDV Dahil)</small>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-right">
                    {{ detail.head.order_price | currency }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'

import CounterTo from '@/components/CounterTo.vue'
import store from '@/store'
import orderStoreModule from '@/views/order/orderStoreModule'
import { useRouter } from '@core/utils'
import {
  mdiCalendar,
  mdiCheckBold,
  mdiArrowLeft,
  mdiContactlessPayment,
  mdiFormatListText,
  mdiMapMarker,
  mdiQrcodeScan,
  mdiReceipt,
  mdiTruckFast,
} from '@mdi/js'
import { onMounted, ref } from '@vue/composition-api'

export default {
  components: {
    CounterTo,
  },

  setup() {
    const PRODUCT_APP_STORE_MODULE_NAME = 'app-order'
    const detail = ref({})
    const pageLoading = ref(true)
    const { router } = useRouter()
    const statusFind = (arr, value, select) => store.state.tanimlar[arr].find(item => item.value === value)[select]
    const { isDark } = useAppConfig()

    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule)
    }
    onMounted(() => {
      if (!router.currentRoute.query.id) {
        router.push({ name: 'order-tracking' })
      }
      const { id } = router.currentRoute.query

      // const id = 11096
      const method = 'getOrderDetail'
      store.dispatch('postMethod', { method, id }).then(response => {
        detail.value = response.detail
        pageLoading.value = false
      })
    })

    return {
      statusFind,
      pageLoading,
      detail,
      isDark,
      icons: {
        mdiCalendar,
        mdiFormatListText,
        mdiReceipt,
        mdiMapMarker,
        mdiCheckBold,
        mdiQrcodeScan,
        mdiTruckFast,
        mdiContactlessPayment,
        mdiArrowLeft,
      },

      // Icons
    }
  },
}
</script>

<style></style>
